import ForgotUsername from "components/ForgotUsername/ForgotUsername";
import AgentForgotUsername from "components/AgentPortal/ForgotUsername/AgentForgotUsername";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { isAgentPortal } from "js/utilities";

export default function ForgotUsernameContainer() {
  useBreadcrumb([]);

  return (
    <>
      {/* Forgot username */}
      <div className="container mb-8">
        <h1>Forgot Username</h1>
        <p>Please follow these steps to recover your username</p>
        <hr />
      </div>
      {isAgentPortal() ? <AgentForgotUsername /> : <ForgotUsername />}
    </>
  );
}
